import { useTranslation } from 'react-i18next';
import { SEO } from '@/hooks/useSEO';

export default function PrivacyPolicyPage() {
  const { t } = useTranslation();

  const sections = [
    { titleKey: 'privacyPolicy.intro.title', contentKey: 'privacyPolicy.intro.content' },
    { titleKey: 'privacyPolicy.dataCollected.title', contentKey: 'privacyPolicy.dataCollected.content' },
    { titleKey: 'privacyPolicy.purposes.title', contentKey: 'privacyPolicy.purposes.content' },
    { titleKey: 'privacyPolicy.legalBasis.title', contentKey: 'privacyPolicy.legalBasis.content' },
    { titleKey: 'privacyPolicy.consent.title', contentKey: 'privacyPolicy.consent.content' },
    { titleKey: 'privacyPolicy.thirdParty.title', contentKey: 'privacyPolicy.thirdParty.content' },
    { titleKey: 'privacyPolicy.internationalTransfer.title', contentKey: 'privacyPolicy.internationalTransfer.content' },
    { titleKey: 'privacyPolicy.retention.title', contentKey: 'privacyPolicy.retention.content' },
    { titleKey: 'privacyPolicy.rights.title', contentKey: 'privacyPolicy.rights.content' },
    { titleKey: 'privacyPolicy.contact.title', contentKey: 'privacyPolicy.contact.content' },
  ];

  return (
    <div className="container max-w-4xl py-12">
      <SEO
        title={t('privacyPolicy.title')}
        description={t('meta.privacyPolicy')}
        path="/integritetspolicy"
      />
      <h1 className="text-3xl font-bold tracking-tight mb-2">{t('privacyPolicy.title')}</h1>
      <p className="text-muted-foreground mb-8">{t('privacyPolicy.lastUpdated')}</p>

      <div className="space-y-8">
        {sections.map((section) => (
          <section key={section.titleKey}>
            <h2 className="text-xl font-semibold mb-3">{t(section.titleKey)}</h2>
            <div
              className="text-sm text-muted-foreground leading-relaxed whitespace-pre-line"
              dangerouslySetInnerHTML={{ __html: t(section.contentKey) }}
            />
          </section>
        ))}
      </div>
    </div>
  );
}
